import { useRouter } from 'next/router';

/** For use with Nextjs pages only!
 * !warning: do not use setParam or removeParam multiple times in a single function it will not work
 * If you use multiple useAppParams then you will have to create a separate function to update multiple at once
 */
export const useAppParam = (paramName: string) => {
  const router = useRouter();

  const param = router.query[paramName];

  const setParam = (paramValue: any) => {
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, [paramName]: paramValue },
      },
      undefined,
      {
        shallow: true,
        scroll: false,
      },
    );
  };

  const removeParam = () => {
    // eslint-disable-next-line no-unused-vars
    const { [paramName]: dummy, ...rest } = router.query;

    router.replace(
      {
        pathname: router.pathname,
        query: { ...rest },
      },
      undefined,
      {
        shallow: true,
        scroll: false,
      },
    );
  };

  return {
    param,
    setParam,
    removeParam,
  };
};
